import cryptographicallyRandomValue from './cryptographicallyRandomValue';

/**
 * Generate a random string
 *
 * @param {string} length
 * @param {string} charSet
 * @param {function} rand
 *
 * @return {string}
 */
const generateRandomString = (
  length = 10,
  charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
  rand = cryptographicallyRandomValue,
) => {
  let code = '';
  while (code.length < length) {
    code += charSet[Math.floor(rand() * charSet.length)];
  }
  return code;
};

export default generateRandomString;



// WEBPACK FOOTER //
// ./src/utilities/generateRandomString.js